import { Link } from 'react-router-dom';
import { blogPosts } from '@/mocks/blogPosts';

const posts = blogPosts.slice(0, 6).map((p, i) => ({
  ...p,
  img: `/images/blog/blog-${i + 1}.webp`,
}));

export default function Blog() {
  return (
    <section id="blog" className="py-20 bg-[#1e1e1e]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex items-end justify-between mb-12">
          <div>
            <div className="inline-flex items-center gap-2 text-red-400 text-sm font-semibold uppercase tracking-widest mb-3">
              <span className="w-8 h-0.5 bg-red-500 inline-block"></span>
              İçerikler
            </div>
            <h2 className="text-4xl font-black text-white">Blog Yazılarımız</h2>
            <p className="text-gray-400 mt-2 text-base">
              Lightbox dünyasından haberler, ipuçları ve sektör bilgileri.
            </p>
          </div>
          <Link
            to="/blog"
            className="hidden md:inline-flex items-center gap-2 border border-gray-600 text-gray-300 hover:border-red-500 hover:text-red-500 text-sm font-semibold px-5 py-2.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
          >
            Tüm Yazılar
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              className="bg-[#2a2a2a] rounded-2xl overflow-hidden group cursor-pointer hover:-translate-y-1 transition-transform duration-300 block"
            >
              <div className="relative overflow-hidden h-40 md:h-44">
                <img
                  src={post.img}
                  alt={post.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-red-600 text-white text-xs font-semibold px-3 py-1 rounded-full">
                    {post.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 text-gray-400 text-xs mb-3">
                  <i className="ri-calendar-line"></i>
                  {post.date}
                </div>
                <h3 className="text-white font-bold text-sm leading-snug mb-4 line-clamp-3">
                  {post.title}
                </h3>
                <span className="inline-flex items-center gap-1 text-red-400 text-sm font-semibold group-hover:gap-2 transition-all">
                  Daha Fazla <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        {/* Mobile CTA */}
        <div className="md:hidden text-center mt-8">
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 border border-gray-600 text-gray-300 text-sm font-semibold px-5 py-2.5 rounded-md cursor-pointer whitespace-nowrap"
          >
            Tüm Yazılar <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
